import { useState, useEffect } from "react";

export default function KeyboardHints() {
  const [visible, setVisible] = useState(() => {
    return !localStorage.getItem("verify_hints_dismissed");
  });

  useEffect(() => {
    if (!visible) return;

    let count = 0;
    const handler = () => {
      count += 1;
      if (count >= 10) {
        setVisible(false);
        localStorage.setItem("verify_hints_dismissed", "true");
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 flex gap-2 opacity-60 hover:opacity-90 transition-opacity z-20 pointer-events-none">
      {[
        { key: "Tab", action: "Next field" },
        { key: "Enter", action: "Verify" },
        { key: "Shift+Enter", action: "Edit" },
        { key: "Esc", action: "Cancel" },
      ].map(({ key, action }) => (
        <div
          key={key}
          className="flex items-center gap-1 px-2 py-1 bg-bark-800/80 text-white text-[10px] rounded-md"
        >
          <kbd className="font-mono font-bold">{key}</kbd>
          <span className="text-bark-300">{action}</span>
        </div>
      ))}
    </div>
  );
}
